import {
  expandProfileQuestionBlocks,
  groupProfileQuestionBlocks,
  type QuestionLike,
} from '../../utils/profileQuestionBlocks';

type QuestionSectionBlocksProps = {
  source: QuestionLike;
  badgeLabel?: string;
  variant?: 'incoming' | 'outgoing';
};

export function QuestionSectionBlocks({
  source,
  badgeLabel = 'Q',
  variant = 'incoming',
}: QuestionSectionBlocksProps) {
  const blocks = expandProfileQuestionBlocks(source);
  const grouped = groupProfileQuestionBlocks(blocks);
  const isMine = variant === 'outgoing';

  if (!blocks.length) {
    return null;
  }

  return (
    <>
      {Object.entries(grouped).map(([section, sectionBlocks]) => (
        <div key={section} className="mh-question-section-group">
          <div className="mh-question-section-label">{section}</div>
          {sectionBlocks.map((block, index) => (
            <div
              key={`${section}-${index}`}
              className={`mh-bubble-row${isMine ? ' mh-bubble-row--mine' : ''}`}
            >
              <div className={`mh-bubble${isMine ? ' mh-bubble--mine' : ''}`}>
                <span className="mh-question-badge">{badgeLabel}</span>
                <p className="mh-bubble-body">{block.questionText}</p>
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
}
